import { useMutation } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { EarlyAccessRequestSchema } from '../schemas/bizy-early-access';

const headers = { 'Key-Inflection': 'camel' };

const earlyAccessRequestsPath = () => '/bizy/early_access_requests';

type CreateEarlyAccessRequestPayload = {
	/** Which surface the opt-in came from (e.g. `side_panel`). */
	source: string;
};

/**
 * Joins the Bizy early-access list (BIZY-322). Recording interest does NOT
 * enable Bizy — the Bonusly team grants access manually. Idempotent per
 * user + source on the backend, so re-submitting is safe.
 */
export const useCreateEarlyAccessRequest = () => {
	const http = useHttpClient();

	return useMutation({
		mutationFn: async (payload: CreateEarlyAccessRequestPayload) => {
			const res = await http.post(earlyAccessRequestsPath(), { earlyAccessRequest: payload }, { headers });
			return EarlyAccessRequestSchema.parse(res.data);
		},
	});
};
